<script lang="ts">
  import DialogWrapper from '../ui/dialog-wrapper.svelte';
  import Card from '../ui/card.svelte';

  let {
    open = true,
    onClose
  }: {
    open?: boolean;
    onClose: () => void;
  } = $props();
</script>

<DialogWrapper {open} {onClose} title="🎮 Systém gamifikace">
  <div class="space-y-6">
    <div class="space-y-4 text-foreground/80">
        <Card class="p-5">
          <h3 class="mb-3 flex items-center gap-2 text-lg font-semibold text-foreground">
            <span>⚡</span> Získávání XP
          </h3>
          <ul class="space-y-2 text-sm">
            <li class="flex items-start gap-2">
              <span class="text-purple-500">•</span>
              <span><strong>1 XP</strong> za otevření kartičky (jednou za session)</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-purple-500">•</span>
              <span><strong>5 XP</strong> za označení slovíčka jako naučené</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-purple-500">•</span>
              <span><strong>2 XP</strong> za správnou odpověď v testu</span>
            </li>
          </ul>
        </Card>

        <Card class="p-5">
          <h3 class="mb-3 flex items-center gap-2 text-lg font-semibold text-foreground">
            <span>🚀</span> Multiplikátory XP
          </h3>
          <ul class="space-y-2 text-sm">
            <li class="flex items-start gap-2">
              <span class="text-secondary">•</span>
              <span><strong>2× XP</strong> když splníš týdenní cíl</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-secondary">•</span>
              <span><strong>1.5× XP</strong> comeback boost po 2 úspěšných týdnech po sestupu</span>
            </li>
          </ul>
        </Card>

        <Card class="p-5">
          <h3 class="mb-3 flex items-center gap-2 text-lg font-semibold text-foreground">
            <span>🏆</span> Ligy
          </h3>
          <div class="space-y-1.5 text-sm">
            <div class="flex items-center justify-between rounded-lg bg-zinc-200 px-3 py-2 text-zinc-900">
              <span>🫧 Cínová</span>
              <span class="text-xs text-zinc-700">100 XP/týden</span>
            </div>
            <div class="flex items-center justify-between rounded-lg bg-orange-200 px-3 py-2 text-orange-900">
              <span>🥉 Bronzová</span>
              <span class="text-xs text-orange-700">200 XP/týden, 3 týdny streak</span>
            </div>
            <div class="flex items-center justify-between rounded-lg bg-gray-200 px-3 py-2 text-gray-900">
              <span>🥈 Stříbrná</span>
              <span class="text-xs text-gray-700">400 XP/týden, 7 týdnů streak</span>
            </div>
            <div class="flex items-center justify-between rounded-lg bg-yellow-200 px-3 py-2 text-yellow-900">
              <span>🥇 Zlatá</span>
              <span class="text-xs text-yellow-800">600 XP/týden, 14 týdnů streak</span>
            </div>
            <div class="flex items-center justify-between rounded-lg bg-slate-300 px-3 py-2 text-slate-900">
              <span>💎 Platinová</span>
              <span class="text-xs text-slate-700">800 XP/týden, 28 týdnů streak</span>
            </div>
            <div class="flex items-center justify-between rounded-lg bg-cyan-200 px-3 py-2 text-cyan-900">
              <span>🔷 Diamantová</span>
              <span class="text-xs text-cyan-700">1000 XP/týden, 52 týdnů streak</span>
            </div>
          </div>
        </Card>

        <Card class="p-5">
          <h3 class="mb-3 flex items-center gap-2 text-lg font-semibold text-foreground">
            <span>🔥</span> Týdenní cyklus
          </h3>
          <ul class="space-y-2 text-sm">
            <li class="flex items-start gap-2">
              <span class="text-primary">•</span>
              <span>Týden začína v <strong>pondělí 00:00</strong></span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-primary">•</span>
              <span>Máš <strong>2 dny grace period</strong> (pondělí-úterý) na dohnání cíle</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-primary">•</span>
              <span><strong>Splníš cíl:</strong> streak +1, možný postup do vyšší ligy</span>
            </li>
            <li class="flex items-start gap-2">
              <span class="text-destructive">•</span>
              <span><strong>Nesplníš cíl:</strong> streak -1, možný sestup do nižší ligy</span>
            </li>
          </ul>
        </Card>
      </div>
    </div>
</DialogWrapper>
